import axios from 'axios'
// import { setCategory } from '../redux/categorySlice'

export const getMonthSales = (code) => {
  
    try {
      const response = axios.get(`https://fp.nemo-monitoring.kz/api/v1/get-sales/${code}/`)
    //   dispatch(setCategory(response.data))
      console.log([].concat(response.data).reverse())
      return response.data
    } catch (e) {
      alert(e)
    }
}

export const assetsApi = {
  async getSales(code) {
      return await axios.get(`https://fp.nemo-monitoring.kz/api/v1/get-sales/${code}/`)
  }
}

export default assetsApi;